var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCalendar = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33333 3.16675C2.8731 3.16675 2.5 3.53984 2.5 4.00008V13.3334C2.5 13.7937 2.8731 14.1667 3.33333 14.1667H12.6667C13.1269 14.1667 13.5 13.7937 13.5 13.3334V4.00008C13.5 3.53984 13.1269 3.16675 12.6667 3.16675H3.33333ZM1.5 4.00008C1.5 2.98756 2.32081 2.16675 3.33333 2.16675H12.6667C13.6792 2.16675 14.5 2.98756 14.5 4.00008V13.3334C14.5 14.3459 13.6792 15.1667 12.6667 15.1667H3.33333C2.32081 15.1667 1.5 14.3459 1.5 13.3334V4.00008Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6667 0.833252C10.9428 0.833252 11.1667 1.05711 11.1667 1.33325V3.99992C11.1667 4.27606 10.9428 4.49992 10.6667 4.49992C10.3905 4.49992 10.1667 4.27606 10.1667 3.99992V1.33325C10.1667 1.05711 10.3905 0.833252 10.6667 0.833252Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33334 0.833252C5.60948 0.833252 5.83334 1.05711 5.83334 1.33325V3.99992C5.83334 4.27606 5.60948 4.49992 5.33334 4.49992C5.05719 4.49992 4.83334 4.27606 4.83334 3.99992V1.33325C4.83334 1.05711 5.05719 0.833252 5.33334 0.833252Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 6.66675C1.5 6.39061 1.72386 6.16675 2 6.16675H14C14.2761 6.16675 14.5 6.39061 14.5 6.66675C14.5 6.94289 14.2761 7.16675 14 7.16675H2C1.72386 7.16675 1.5 6.94289 1.5 6.66675Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCalendar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/calendar.149051be.svg";
export { ForwardRef as ReactComponent };